<template>
    <div class="filter-brands">
        <!-- <transition name="toggle" mode="out-in" :duration="200"> -->
            <!-- <div class="types-of-transport-slider--preloader">  <div class="types-of-transport-item">   </div>  </div> -->
            <!-- <div class="owl-carousel owl-theme filter-car-type">
                <label
                v-for="(type, index) in vehicle_type"
                class="filter-car-type-label"
                :for="'sedan' + type.id"
                :key="index"
                >
                <input
                    type="checkbox"
                    :id="'sedan' + type.id"
                    :value="type.id"
                    v-model="filters.vt"
                    @click="updExtra"
                />
                <div class="filter-car-type-wrap">
                    <span>{{ type.name }}</span>
                    <img v-if="type.icon" :src="'/img/vt/' + type.icon" width="56px" height="20px" />
                    <svg
                    v-if="!type.icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 20"
                    width="56px"
                    height="20px"
                    >
                    <g fill="currentColor" fill-rule="evenodd">
                        <path
                        d="M44.1336643 5.22650042c-.0910535.26398614-.3429548.80753399-.5030003 1.04516145-.1119116.16613954-.2523024.27037612-.5194462.27916234-.732038.02436181-1.5202323.06190296-2.3369059.10463596l.278375-3.61712925c1.2033501.55592845 2.7328081 1.35068247 2.962648 1.66379159.1716779.23363373.1861181.32628847.1183294.52437791zM40.1553888 6.6886082c-2.316449.1270009-4.7997626.28275671-6.8434522.30751789-.8291083.00998435-.8780445.21166816-.7865899-.53276476.3337291-2.72093425.3938966-3.62152236.6502102-4.28288551.0417161-.10743157.2627314-.21047003.4448384-.20847316l3.1856689.03754114c.95185.01158185 1.9353882.18451074 2.8748035.46007871.1556333.04313238.450053.15935018.8162725.31909974l-.3417514 3.89988595zm-8.4980587-4.31643291c-.3192889.85346198-.4476462 2.69777057-.6397811 3.93622898-.092658.5978627-.2346533.73964043-.8483619.74443291-2.4227449.02036807-8.9196323.48364177-8.8899497.36782335.027276-.1070322.1700735-.51199732.195745-.93772988.0433206-.71967173-1.2779579-.77318783-2.0978404-.72007111 1.5896255-1.17655545 3.9477907-2.42899195 6.0588679-3.15744991.7428682-.2476118 2.7584796-.56591279 4.1543658-.59586583l1.7953984-.03754114c.3241023-.00399374.3670218.14617084.271556.40017263zM55.7243328 12.4579633c-.0024067-.2204544-.5631678-.2208538-.5768058-.4504937-.0814267-1.3962111-.1792992-2.94138868-.3325258-4.37554029-.1841125-1.7217008-3.729182-1.78520125-5.9020313-2.46972808-1.5451015-.48683677-2.8178449-1.53119947-4.8025703-2.40502952-2.185685-.96249106-4.0933961-1.84510734-6.3913937-1.84510734-3.7343966 0-9.2850497-.443305-12.7615282.65697004-3.3292687 1.05314893-6.3625133 2.95696422-9.5205052 4.44143694-3.8214389.403767-8.06405036 1.17655546-11.93562887 2.13225716-1.25228637.30911538-1.7978051.88661002-2.18247603 1.62824731-.41956808.80833278-.61812085 1.56634438-.80985464 2.02522498-.30685428.0251605-.31848667-.0527174-.41555691.1262021-.10188365.186907-.04492508.4365157-.06738761.7440336-.0505407.6957093-.03890832 1.6122723.13718191 2.2364937.16927126.5990608.3241023.8890063.6213298 1.1094607.22703205.1685357.49618136.2979329.81547027.3083166l1.41834869.0463274c.84635626-.1553565.68671181-.2635868.63296217-1.3355063-.00802233-.1609477-.0120335-.3234928-.0120335-.4876355 0-2.9789298 2.42595387-5.39394366 5.41788343-5.39394366 2.99192959 0 5.41748229 2.41501386 5.41748229 5.39394366 0 .3027254-.0064178.6002589-.0264737.889805-.127154 1.8067674-.2964252 1.4948564 1.3497578 1.5767281l22.7300807-.0247612c1.209768-.1661395 1.141177-.0143775 1.0144241-1.5280045-.0248692-.2971341-.0332926-.6026552-.0332926-.9137674 0-2.9789298 2.4255527-5.39394366 5.4174823-5.39394366 2.9923306 0 5.4174823 2.41501386 5.4174823 5.39394366 0 .2555993-.0072201.5096011-.0264737.7608072-.0970703 1.2384584.2506979 1.1374168 1.0629593 1.0751145.845554-.0642992 1.8042229-.1437746 2.560729-.2731717.5912461-.1010416 1.0585471-.2324356 1.2514842-.4109557.6125052-.5663122.5419087-2.3323435.5314796-3.2377241z"
                        />
                        <path
                        d="M9.16720152 17.1027487c-1.18128872 0-2.13915542-.9537049-2.13915542-2.129861 0-1.1757567.9578667-2.1294615 2.13915542-2.1294615 1.18128868 0 2.13875428.9537048 2.13875428 2.1294615 0 1.1761561-.9574656 2.129861-2.13875428 2.129861m0-6.2789562C6.86559383 10.8237925 5 12.6816798 5 14.9728877c0 2.2916074 1.86559383 4.1494947 4.16720152 4.1494947 2.30160768 0 4.16720148-1.8578873 4.16720148-4.1494947 0-2.2912079-1.8655938-4.1490952-4.16720148-4.1490952M45.1672015 17.1027487c-1.1812887 0-2.1387543-.9537049-2.1387543-2.129861 0-1.1757567.9574656-2.1294615 2.1387543-2.1294615s2.1391554.9537048 2.1391554 2.1294615c0 1.1761561-.9578667 2.129861-2.1391554 2.129861m0-6.2789562C42.8659949 10.8237925 41 12.6816798 41 14.9728877c0 2.2916074 1.8659949 4.1494947 4.1672015 4.1494947 2.3016077 0 4.1672015-1.8578873 4.1672015-4.1494947 0-2.2912079-1.8655938-4.1490952-4.1672015-4.1490952"
                        />
                    </g>
                    </svg>
                </div>
                </label>
            </div>
        </transition> -->
        <transition name="toggle" mode="out-in" :duration="200">
            <div class="filters-car-brand--empty" v-if="!hasBrands" key="empty">
                <label v-for="n in 8" :key="n" class="car-filter">
                    <div class="car-filter-checkmark">
                        <span class="empty-block--image shine-short"></span>
                        <span class="empty-block--title shine-short"></span>
                    </div>
                </label>
            </div>
            <div class="filters-car-brand--full" v-else key="full">
                <label
                    v-for="(brand, index) in cropBrands"
                    class="car-filter"
                    :for="brand.company"
                    :key="index"
                >
                    <input type="checkbox" :id="brand.company" :value="brand.id" v-model="filters.brands" />
                    <div class="car-filter-checkmark">
                        <img :src="brand.logo" :alt="`${brand.company}-logo`" />
                        <span>{{ brand.company }}</span>
                    </div>
                </label>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        brands: {
            type: Array,
            default: () => []
        },
        filters: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        hasBrands() {
            return this.brands.length
        },
        cropBrands() {
            return this.brands.slice(0, 8)
        }
    }
}
</script>
